import { fetchBookingData, fetchBookingDetail, postBooking } from "../data/apiClient";

export const bookingRepository = {
    getBookingData: async () => {
        const response = await fetchBookingData();
        const bookingData = response.data;
        return bookingData;
    },

    getBookingDetail: async (bookingId) => {
        const response = await fetchBookingDetail(bookingId);
        // Tolerates the backend returning the raw query rows instead of a single object.
        const bookingDetail = Array.isArray(response.data) ? response.data[0] : response.data;
        return bookingDetail ?? null;
    },

    postBooking: async (formBody) => {
        try {
            const response = await postBooking(formBody);
            return { success: response.status === 200 };
        } catch (error) {
            return { success: false, message: 'Something went wrong' };
        }
    }
}